"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortingReducer = void 0;
const sorting_1 = require("../actions/sorting");
const getInitialSortingObject = () => ({
    favorites: typeof SETUPS !== 'undefined' ? SETUPS.get('stockcar.scs.sort.param') : 'prices.retail:asc',
    results: typeof SETUPS !== 'undefined' ? SETUPS.get('stockcar.scs.sort.param') : 'prices.retail:asc',
});
const sortingReducer = (sorting = getInitialSortingObject(), action) => {
    switch (action.type) {
        case sorting_1.SET_SORTING:
            return Object.assign(Object.assign({}, sorting), action.payload);
        case sorting_1.RESET_SORTING:
            return getInitialSortingObject();
        default:
            return sorting;
    }
};
exports.sortingReducer = sortingReducer;
//# sourceMappingURL=sorting.reducer.js.map